import { Button } from "@/components/ui/button";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="border-b border-gray-200 bg-white/95 backdrop-blur-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <a className="flex items-center space-x-2" href="/">
            <img
              src="/Logo Docuveritas.png"
              alt="Docuveritas Logo"
              className="w-9 h-9 object-contain"
            />
            <span className="text-xl font-bold text-gray-900">Docuveritas</span>
          </a>

          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="/"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Accueil
            </a>
            <a
              href="/features"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Fonctionnalités
            </a>
            <a
              href="/pricing"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Tarifs
            </a>
            <a
              href="/about"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              À propos
            </a>
            <a
              href="/contact"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Contact
            </a>
          </nav>

          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              className="text-gray-700 hover:text-blue-600"
              onClick={() => navigate("/signin")}
            >
              Connexion
            </Button>
            <Button
              className="bg-blue-600 hover:bg-blue-700 text-white"
              onClick={() => navigate("/signup")}
            >
              Inscription
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
